import { getApi } from '../services/apiService';
import { API_URLS } from './constants';

export const fetchImportStatus = async (): Promise<ListImportExportApiResponse> => {
    const GET_STATUS = API_URLS.getImportStatus();
    const response = await getApi({ url: GET_STATUS });
    const responseData = response?.data?.data ?? {};
    responseData.inProgress = responseData?.inProgress?.map((item: ImportExportAPIResponse) => ({
        ...item,
        status: item.status === 'inprogress' ? 'IN_PROGRESS' : item.status.toUpperCase()
    }));

    responseData.completed = responseData?.completed?.map((item: ImportExportAPIResponse) => ({
        ...item,
        status: item.status === 'completed' ? 'FINISHED' : item.status.toUpperCase(),
        progressDetails: {
            noOfRecords: item.noOfRecords,
            jobError: item.jobError,
            importFilename: item.fileName
        }
    }));
    return responseData;
};

export const getDelayForFileSize = (fileSize: number) => {
    if (fileSize <= 5 * 1024 * 1024) return 500; // 5MB or less
    return 1000; // above 5MB
};

export const pollImportStatus = async (
    setPollingData: (inProgress: ImportExportAPIResponse[], completed: ImportExportAPIResponse[]) => void,
    setPollingInProgress: (value: boolean) => void,
    fileSize: number
) => {
    setPollingInProgress(true);
    const delay = getDelayForFileSize(fileSize);

    const intervalId = setInterval(async () => {
        const data = await fetchImportStatus();

        setPollingData(data.inProgress, data.completed);

        const allCompletedOrFailed = [...data.inProgress, ...data.completed].every(
            (item) => item.status === 'FINISHED' || item.status === 'FAILED'
        );

        if (allCompletedOrFailed) {
            clearInterval(intervalId);
            setPollingInProgress(false);
        }
    }, delay);
    return intervalId;
};
